import { useQueryClient } from '@tanstack/react-query'
import { useMap } from '~map-preview/states/map'

export const useRefetchMap = () => {
  const map = useMap()
  const query = useQueryClient()
  return {
    refetch: () =>
      query.invalidateQueries({
        queryKey: ['getMapById', map.id]
      })
  }
}
